import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '='
    },
    template: `
        <form-wrapper form="vm.form">
            <form-row error="vm.form.errors.categoryI18ns[vm.defaultLanguage].name">
                <label class="label">{{ 'formCategory.Category name' | translate }} *</label>
                <div class="items">
                    <input ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()" ng-model="vm.form.model.categoryI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.parentCategoryId">
              <label class="label">{{ 'formCategory.Parent category' | translate }}</label>
              <div class="items">
                <select class="form-control"
                        ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()"
                        ng-model="vm.form.model.parentCategoryId"
                        ng-options="item.id as item.name for item in vm.selectItems track by item.id">
                  <option value=""></option>
                </select>
                <form-row-error></form-row-error>
              </div>
            </form-row>
            <form-row error="vm.form.errors.status">
                <span class="label">{{ 'formCategory.Status' | translate }}</span>
                <div class="items">
                    <ul class="checkboxes">
                        <li>
                            <label ng-repeat="item in vm.FORMS_CATEGORY_FORMS_ENUM.KEYS">
                                <input
                                    ng-disabled="!vm.QuestionService.canManageQuestionRelatedData()"
                                    ng-model="vm.form.model.status"
                                    value="{{ vm.FORMS_CATEGORY_FORMS_ENUM.KEYS[item] }}"
                                    type="radio"
                                > {{ vm.FORMS_CATEGORY_FORMS_ENUM.LABELS[item] }}
                            </label>
                        </li>
                    </ul>
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </form-wrapper>
    </form>
    `
})
export default class {
    constructor (FormCategoryResource, ListFactory, FORMS_CATEGORY_FORMS_ENUM, TokenService, FormCategoryService, QuestionService) {
        this.FORMS_CATEGORY_FORMS_ENUM = FORMS_CATEGORY_FORMS_ENUM;
        this.ListFactory = ListFactory;
        this.FormCategoryResource = FormCategoryResource;
        this.FormCategoryService = FormCategoryService;
        this.QuestionService = QuestionService;

        this.defaultLanguage = TokenService.getCompanyLanguage();
    }

    $onInit () {
        // angular select can not handle selected model values as integers, so convert to string
        if (this.form.model.parentCategoryId) {
            this.form.model.parentCategoryId = this.form.model.parentCategoryId.toString();
        }

        if (!this.form.model.status) {
            this.form.model.status = this.FORMS_CATEGORY_FORMS_ENUM.KEYS.ACTIVE;
        }
        this.list = this.ListFactory.createWithPagination(this.FormCategoryResource.tree.bind(this.FormCategoryResource));
        this.list.fetch({ pageSize: 0 }).then((result) => {
            this.selectItems = this.FormCategoryService.mapSelectItems(result);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/formcategories/generaldata/index.js